<template>
    <v-card class="pa-3 ma-3">
        <v-row dense>
            <v-col cols="12" md="12">
                <v-toolbar flat color="#1d2735" dark>
                    <v-icon class="white--text" style="font-size: 45px">
                        mdi-cash-plus
                    </v-icon>
                    <pre><v-toolbar-title><h2>Lista Ingresos</h2></v-toolbar-title></pre>
                </v-toolbar>
            </v-col>
        </v-row>
        <loader :loading="isloading"></loader>
        <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    fab
                    :to="'/contabilidad'"
                    :loading="isloading"
                    :disabled="isloading"
                    color="blue"
                    class="mt-2 mx-3"
                    v-bind="attrs"
                    v-on="on"
                >
                    <v-icon class="white--text"
                        >mdi-arrow-left-bold-outline</v-icon
                    >
                </v-btn>
            </template>
            <span>Volver</span>
        </v-tooltip>
        <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    fab
                    :to="{ path: `/guardar-ingreso` }"
                    :loading="isloading"
                    :disabled="isloading"
                    color="orange darken-1"
                    class="mt-2"
                    v-bind="attrs"
                    v-on="on"
                >
                    <v-icon class="white--text">mdi-plus-box</v-icon>
                </v-btn>
            </template>
            <span>Nuevo Ingreso</span>
        </v-tooltip>
        <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    fab
                    @click="Exportar"
                    :loading="isloading"
                    :disabled="isloading"
                    color="green darken-1"
                    class="ml-3 mt-2"
                    v-bind="attrs"
                    v-on="on"
                >
                    <v-icon class="white--text">mdi-file-excel</v-icon>
                </v-btn>
            </template>
            <span>Exportar</span>
        </v-tooltip>
        <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    fab
                    @click="abrirDialogImportar"
                    :loading="isloading"
                    :disabled="isloading"
                    color="purple darken-1"
                    class="ml-3 mt-2"
                    v-bind="attrs"
                    v-on="on"
                >
                    <v-icon class="white--text">mdi-file-import</v-icon>
                </v-btn>
            </template>
            <span>Importar Ingresos</span>
        </v-tooltip>
        <v-tooltip right>
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    fab
                    @click="abrirDialogHistorial"
                    :loading="isloading"
                    :disabled="isloading"
                    color="indigo darken-1"
                    class="ml-3 mt-2"
                    v-bind="attrs"
                    v-on="on"
                >
                    <v-icon class="white--text">mdi-history</v-icon>
                </v-btn>
            </template>
            <span>Historial de Importaciones</span>
        </v-tooltip>
        <v-row>
            <v-col cols="12" md="6" justify="center">
                <FilterComponentVue
                    :headers="filter_headers"
                    v-model="filtros_prueba"
                ></FilterComponentVue>
            </v-col>
            <v-col cols="12" md="4">
                <v-card>
                    <v-card-text>
                        <h3>Total: {{ importe_total | format_precio }}</h3>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>
        <v-data-table
            :headers="headers"
            :server-items-length="total"
            :items="allIngresos"
            :search="search"
            :items-per-page="10"
            item-key="id"
            class="elevation-1"
            :options.sync="options"
            @update:options="onOptionsUpdate"
        >
            <template v-slot:item.fecha="{ item }">
                <template> {{ item.fecha | format_date }} </template></template
            >
            <template v-slot:item.proyecto.nombre="{ item }">
                <span v-if="item.proyecto">{{ item.proyecto.nombre }}</span>
                <span v-else style="color: red !important"
                    ><strong>No Tiene</strong></span
                >
            </template>
            <template v-slot:item.cliente_nombre="{ item }">
                <span v-if="item.cliente_nombre != 'No Tiene'">{{
                    item.cliente_nombre
                }}</span>
                <span v-else style="color: red !important"
                    ><strong>No Tiene</strong></span
                >
            </template>
            <template v-slot:item.nros="{ item }">
                <span v-if="item.facturas_asociadas != ''">{{
                    item.facturas_asociadas
                }}</span>
                <span v-else style="color: red !important"
                    ><strong>No Tiene</strong></span
                >
            </template>
            <template v-slot:item.importe="{ item }">
                {{ item.importe | format_precio }}
            </template>
            <template v-slot:item.tipo_pago="{ item }">
                <span v-if="getTipoPago(item)">{{ getTipoPago(item) }}</span>
                <span v-else style="color: red !important"
                    ><strong>No Tiene</strong></span
                >
            </template>
            <template v-slot:item.descripcion="{ item }">
                <span v-if="item.descripcion">{{ item.descripcion }}</span>
                <span v-else style="color: red !important"
                    ><strong>No Tiene</strong></span
                >
            </template>
            <template v-slot:item.action="{ item }">
                <router-link
                    :to="{ path: `/guardar-ingreso?id=${item.id}` }"
                    class="action-buttons"
                >
                    <v-icon
                        small
                        class="mr-2"
                        color="#1d2735"
                        style="font-size: 25px"
                        title="EDITAR"
                        >mdi-pencil-outline</v-icon
                    >
                </router-link>
                <v-icon
                    @click="openModal(item)"
                    small
                    class="mr-2"
                    color="red"
                    style="font-size: 25px"
                    title="BORRAR"
                    >mdi-trash-can</v-icon
                >
            </template>
        </v-data-table>

        <v-dialog v-model="dialog" max-width="500px">
            <v-card>
                <v-card-title
                    class="text-h5 aviso"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Aviso
                </v-card-title>
                <v-card-text style="text-align: center">
                    <h2>¿Estás seguro que deseas eliminar?</h2>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="
                            dialog = false;
                            selectedItem = {};
                        "
                        >Cancelar</v-btn
                    >
                    <v-btn color="success" large @click="deleteIngreso()"
                        >Confirmar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogImportar" max-width="800px" persistent>
            <v-card>
                <v-card-title
                    class="text-h5"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Importar Ingresos desde CSV/Excel
                </v-card-title>
                <v-card-text class="pt-4">
                    <v-file-input
                        v-model="archivoImportar"
                        label="Seleccionar archivo CSV o Excel"
                        accept=".csv,.txt,.xlsx,.xls"
                        prepend-icon="mdi-file-document"
                        outlined
                        dense
                    ></v-file-input>

                    <v-alert
                        v-if="resumenImportacion"
                        type="info"
                        class="mt-4"
                    >
                        <h3>Resumen de Importación</h3>
                        <p><strong>Total filas procesadas:</strong> {{ resumenImportacion.total_filas }}</p>
                        <p><strong>Ingresos creados:</strong> {{ resumenImportacion.ingresos_creados }}</p>
                        <p><strong>Ingresos duplicados:</strong> {{ resumenImportacion.ingresos_duplicados }}</p>
                        <p><strong>Errores:</strong> {{ resumenImportacion.errores }}</p>
                    </v-alert>

                    <v-expansion-panels v-if="resumenImportacion && resumenImportacion.detalles.length > 0" class="mt-4">
                        <v-expansion-panel>
                            <v-expansion-panel-header>
                                Detalles de Ingresos Creados ({{ resumenImportacion.detalles.length }})
                            </v-expansion-panel-header>
                            <v-expansion-panel-content>
                                <v-simple-table dense>
                                    <thead>
                                        <tr>
                                            <th>Fila</th>
                                            <th>Pedido</th>
                                            <th>Cliente</th>
                                            <th>Factura</th>
                                            <th>Importe</th>
                                            <th>Fecha</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(detalle, index) in resumenImportacion.detalles" :key="index">
                                            <td>{{ detalle.fila }}</td>
                                            <td>{{ detalle.pedido }}</td>
                                            <td>{{ detalle.cliente }}</td>
                                            <td>{{ detalle.factura }}</td>
                                            <td>{{ detalle.importe | format_precio }}</td>
                                            <td>{{ detalle.fecha }}</td>
                                        </tr>
                                    </tbody>
                                </v-simple-table>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-expansion-panels>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="cerrarDialogImportar"
                        :disabled="importando"
                        >{{ resumenImportacion ? 'Cerrar' : 'Cancelar' }}</v-btn
                    >
                    <v-btn
                        color="success"
                        large
                        @click="importarIngresos"
                        :loading="importando"
                        :disabled="!archivoImportar || importando"
                        >Importar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogHistorial" max-width="1200px" persistent scrollable>
            <v-card>
                <v-card-title
                    class="text-h5"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Historial de Importaciones de Ingresos
                </v-card-title>
                <v-card-text class="pt-4">
                    <v-data-table
                        :headers="headersHistorial"
                        :items="historialImportaciones"
                        :loading="cargandoHistorial"
                        :server-items-length="totalHistorial"
                        :items-per-page="10"
                        item-key="id"
                        class="elevation-1"
                        @update:options="onHistorialOptionsUpdate"
                    >
                        <template v-slot:item.fecha_importacion="{ item }">
                            {{ item.fecha_importacion | format_date }} {{ item.fecha_importacion ? new Date(item.fecha_importacion).toLocaleTimeString() : '' }}
                        </template>
                        <template v-slot:item.usuario="{ item }">
                            {{ item.usuario?.nombre_fiscal || item.usuario?.nombre || 'N/A' }}
                        </template>
                        <template v-slot:item.archivo_nombre="{ item }">
                            {{ item.archivo_nombre || 'N/A' }}
                        </template>
                        <template v-slot:item.action="{ item }">
                            <v-btn
                                small
                                color="primary"
                                @click="verDetalleImportacion(item)"
                            >
                                <v-icon small>mdi-eye</v-icon>
                                Ver Detalle
                            </v-btn>
                        </template>
                    </v-data-table>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="cerrarDialogHistorial"
                        >Cerrar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-dialog v-model="dialogDetalleImportacion" max-width="1000px" persistent scrollable>
            <v-card>
                <v-card-title
                    class="text-h5"
                    style="
                        justify-content: center;
                        background: #1d2735;
                        color: white;
                    "
                >
                    Detalle de Importación
                </v-card-title>
                <v-card-text class="pt-4">
                    <v-row v-if="detalleImportacion">
                        <v-col cols="12" md="6">
                            <p><strong>Fecha de importación:</strong> {{ detalleImportacion.fecha_importacion | format_date }} {{ detalleImportacion.fecha_importacion ? new Date(detalleImportacion.fecha_importacion).toLocaleTimeString() : '' }}</p>
                            <p><strong>Usuario:</strong> {{ detalleImportacion.usuario?.nombre_fiscal || detalleImportacion.usuario?.nombre || 'N/A' }}</p>
                            <p><strong>Archivo:</strong> {{ detalleImportacion.archivo_nombre || 'N/A' }}</p>
                        </v-col>
                        <v-col cols="12" md="6">
                            <p><strong>Total filas procesadas:</strong> {{ detalleImportacion.total_filas }}</p>
                            <p><strong>Ingresos creados:</strong> {{ detalleImportacion.ingresos_creados }}</p>
                            <p><strong>Ingresos duplicados:</strong> {{ detalleImportacion.ingresos_duplicados }}</p>
                            <p><strong>Errores:</strong> {{ detalleImportacion.errores }}</p>
                        </v-col>
                    </v-row>

                    <v-card v-if="detalleImportacion && detalleImportacion.resumen && detalleImportacion.resumen.filas_procesadas && detalleImportacion.resumen.filas_procesadas.length > 0" class="mt-4">
                        <v-card-title>Listado de Todas las Filas Procesadas</v-card-title>
                        <v-card-text>
                            <v-simple-table dense>
                                <thead>
                                    <tr>
                                        <th>Fila</th>
                                        <th>Fecha</th>
                                        <th>Número de Pedido</th>
                                        <th>Importe</th>
                                        <th>Resultado</th>
                                        <th>Mensaje</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(fila, index) in detalleImportacion.resumen.filas_procesadas" :key="index">
                                        <td>{{ fila.fila }}</td>
                                        <td>{{ fila.fecha || '-' }}</td>
                                        <td>{{ fila.numero_pedido || '-' }}</td>
                                        <td>{{ fila.importe ? (typeof fila.importe === 'number' ? fila.importe.toFixed(2) + ' €' : fila.importe) : '-' }}</td>
                                        <td>
                                            <v-chip
                                                :color="getColorResultado(fila.resultado)"
                                                small
                                                dark
                                            >
                                                {{ fila.resultado || 'PENDIENTE' }}
                                            </v-chip>
                                        </td>
                                        <td style="max-width: 300px; word-wrap: break-word;">{{ fila.mensaje || '-' }}</td>
                                    </tr>
                                </tbody>
                            </v-simple-table>
                        </v-card-text>
                    </v-card>

                    <v-card v-if="detalleImportacion && detalleImportacion.log" class="mt-4">
                        <v-card-title>Log Completo</v-card-title>
                        <v-card-text>
                            <pre style="white-space: pre-wrap; font-size: 11px; max-height: 400px; overflow-y: auto;">{{ detalleImportacion.log }}</pre>
                        </v-card-text>
                    </v-card>
                </v-card-text>
                <v-card-actions class="pt-3">
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        large
                        @click="cerrarDialogDetalle"
                        >Cerrar</v-btn
                    >
                    <v-spacer></v-spacer>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </v-card>
</template>

<script>
import FormProyectoVue from "../../proyectos/componentes/FormProyecto.vue";
import { date_mixin } from "../mixins/date_mixin";
import FilterComponentVue from "../../../components/general/FilterComponent.vue";
import rangoFechas from "../rangoFechas.vue";
import debounce from "lodash/debounce";

export default {
    mixins: [date_mixin],

    components: {
        rangoFechas,
        FilterComponentVue,
    },

    data() {
        return {
            importe_total: 0,
            filtros_prueba: {
                search: "",
                cliente: { value: null },
                fecha: { start: null, end: null, tipo: 3 },
                tipo_pago: { value: [] },
            },
            dialogImportar: false,
            archivoImportar: null,
            importando: false,
            resumenImportacion: null,
            dialogHistorial: false,
            historialImportaciones: [],
            cargandoHistorial: false,
            totalHistorial: 0,
            optionsHistorial: {
                page: 1,
                itemsPerPage: 10,
            },
            headersHistorial: [
                { text: 'Fecha', value: 'fecha_importacion' },
                { text: 'Usuario', value: 'usuario' },
                { text: 'Archivo', value: 'archivo_nombre' },
                { text: 'Total Filas', value: 'total_filas' },
                { text: 'Creados', value: 'ingresos_creados' },
                { text: 'Duplicados', value: 'ingresos_duplicados' },
                { text: 'Errores', value: 'errores' },
                { text: 'Acciones', value: 'action', sortable: false },
            ],
            dialogDetalleImportacion: false,
            detalleImportacion: null,
            filter_headers: [
                {
                    title: "Cliente",
                    type: "cliente",
                    active: false,
                    model: "cliente",
                    item_text: "nombre",
                    item_value: "id",
                    items: [],
                },
                {
                    title: "Fecha de creación",
                    type: "date",
                    active: true,
                    model: "fecha",
                },
                {
                    title: "Tipo de pago",
                    type: "select_multiple",
                    active: false,
                    model: "tipo_pago",
                    item_text: "label",
                    item_value: "value",
                    items: [
                        { label: "Transferencia", value: "transferencia" },
                        { label: "Tarjeta", value: "tarjeta" },
                        { label: "SEPA", value: "sepa" },
                        { label: "Efectivo", value: "efectivo" },
                    ],
                },
            ],

            url: `api/get-ingresos/${localStorage.getItem("user_id")} `,
            search: "",
            ingresos: [],
            allIngresos: [],
            selectedItem: 0,
            dialog: false,
            delete_id: null,
            headers: [
                { text: "Cliente", align: "left", value: "cliente.nombre" },
                {
                    text: "Nombre Fiscal",
                    align: "left",
                    value: "cliente.nombre_fiscal",
                },
                {
                    text: "Num. Facturas",
                    align: "left",
                    value: "nros",
                    sortable: false,
                },
                { text: "Fecha", value: "fecha" },
                { text: "Importe", value: "importe" },
                { text: "Tipo de pago", value: "tipo_pago", sortable: false },
                { text: "Descripción Ingreso", value: "descripcion" },
                { text: "Acciones", value: "action", sortable: false },
            ],
            options: {
                page: 1,
                itemsPerPage: 15,
                sortBy: [],
                sortDesc: [],
            },
            total: 0,
        };
    },

    created() {
        // this.getIngresos();
        const date = new Date();
        this.filtros_prueba.fecha = {
            tipo: 1,
            start: new Date(date.getFullYear(), date.getMonth(), 1, 12)
                .toISOString()
                .slice(0, 10),
            end: new Date(date.getFullYear(), date.getMonth() + 1, 0, 12)
                .toISOString()
                .slice(0, 10),
        };
        this.getAllingresos();
    },
    watch: {
        filtros_prueba: {
            deep: true,
            handler: debounce(function (n) {
                // console.log(n);
                this.page = 1;
                this.getAllingresos();
            }, 500),
        },
    },
    methods: {
        Exportar() {
            const reqstr = this.Params();

            axios
                .post(
                    `api/exportar-ingresos?amount=-1${reqstr}`,
                    this.filtros2,
                    {
                        responseType: "blob",
                    }
                )
                .then((res) => {
                    const url = window.URL.createObjectURL(
                        new Blob([res.data])
                    );
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute("download", "ingresos.xlsx");
                    document.body.appendChild(link);
                    link.click();
                })
                .catch((err) => {
                    console.error(err);
                });
        },
        Params() {
            let reqstr = "";
            if (this.filtros_prueba.search) {
                reqstr += `&search=${this.filtros_prueba.search}`;
            }
            if (this.filtros_prueba.cliente?.value != null) {
                reqstr += `&id_cliente=${this.filtros_prueba.cliente?.value}`;
            }
            if (this.filtros_prueba.fecha) {
                if (this.filtros_prueba.fecha.start) {
                    reqstr += `&fecha_inicio=${this.filtros_prueba.fecha.start}`;
                }
                if (this.filtros_prueba.fecha.end) {
                    reqstr += `&fecha_fin=${this.filtros_prueba.fecha.end}`;
                }
            }
            if (this.filtros_prueba.tipo_pago?.value && this.filtros_prueba.tipo_pago.value.length > 0) {
                this.filtros_prueba.tipo_pago.value.forEach(tipo => {
                    reqstr += `&tipo_pago[]=${tipo}`;
                });
            }
            return reqstr;
        },

        getAllingresos() {
            const params = {
                page: this.options.page,
                amount: this.options.itemsPerPage,
                sortBy: this.options.sortBy[0],
                sortDesc: this.options.sortDesc[0],
                search: this.filtros_prueba.search,
                id_cliente: this.filtros_prueba.cliente?.value,
                fecha_inicio: this.filtros_prueba.fecha.start,
                fecha_fin: this.filtros_prueba.fecha.end,
            };
            
            if (this.filtros_prueba.tipo_pago?.value && this.filtros_prueba.tipo_pago.value.length > 0) {
                params.tipo_pago = this.filtros_prueba.tipo_pago.value;
            }
            
            axios
                .get(`api/getAllingresos`, {
                    params: params,
                })
                .then(
                    (res) => {
                        this.allIngresos = res.data.data;
                        this.total = res.data.total;
                        this.importe_total = res.data.importe;

                        console.log(this.allIngresos);
                    },
                    (res) => {
                        this.$toast.error("Error consultando ingresos");
                    }
                );
        },
        onOptionsUpdate(newOptions) {
            this.options = newOptions;

            if (this.options.sortBy.length > 0) {
                this.sortBy = this.options.sortBy[0];
            } else {
                this.options.sortBy = [this.sortBy];
            }
            if (this.options.sortDesc.length > 0) {
                this.sortDesc = this.options.sortDesc[0];
            } else {
                this.options.sortDesc = [!this.sortDesc];
            }

            this.getAllingresos();
        },
        getIngresos() {
            axios
                .get(`api/get-ingresos/${localStorage.getItem("user_id")} `)
                .then(
                    (res) => {
                        this.ingresos = res.data;
                    },
                    (res) => {
                        this.$toast.error("Error consultando ingresos");
                    }
                );
        },
        setIngresos(data) {
            if (data.length > 0) {
                this.allIngresos = data;
                return;
            }
            this.$toast.sucs("No se encontraron registros");
        },
        deleteIngreso() {
            this.dialog = false;
            axios.get(`api/delete-ingreso/${this.delete_id}`).then(
                (res) => {
                    //this.ingresos.splice(this.selectedItem, 1);
                    this.$toast.sucs("Ingreso eliminado con exito");
                    this.getAllingresos();
                },
                (err) => {
                    this.$toast.error("Error Eliminando ingreso");
                }
            );
        },
        openModal(item) {
            this.selectedItem = this.ingresos.indexOf(item);
            this.delete_id = item.id;
            this.dialog = true;
        },
        abrirDialogImportar() {
            this.dialogImportar = true;
            this.archivoImportar = null;
            this.resumenImportacion = null;
        },
        cerrarDialogImportar() {
            this.dialogImportar = false;
            this.archivoImportar = null;
            this.resumenImportacion = null;
            this.getAllingresos(); // Refrescar la lista
        },
        importarIngresos() {
            if (!this.archivoImportar) {
                this.$toast.error("Por favor seleccione un archivo");
                return;
            }

            this.importando = true;
            const formData = new FormData();
            formData.append('archivo', this.archivoImportar);

            axios.post('api/importar-ingresos', formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            })
            .then((response) => {
                if (response.data.success) {
                    this.resumenImportacion = response.data.resumen;
                    this.$toast.sucs(
                        `Importación completada. ${response.data.resumen.ingresos_creados} ingresos creados, ` +
                        `${response.data.resumen.ingresos_duplicados} duplicados, ${response.data.resumen.errores} errores.`
                    );
                } else {
                    this.$toast.error("Error en la importación: " + (response.data.error || "Error desconocido"));
                }
            })
            .catch((error) => {
                console.error("Error al importar ingresos:", error);
                this.$toast.error("Error al importar ingresos: " + (error.response?.data?.error || error.message));
            })
            .finally(() => {
                this.importando = false;
            });
        },
        abrirDialogHistorial() {
            this.dialogHistorial = true;
            this.cargarHistorial();
        },
        cerrarDialogHistorial() {
            this.dialogHistorial = false;
        },
        cargarHistorial() {
            this.cargandoHistorial = true;
            axios.get('api/historial-importaciones-ingresos', {
                params: {
                    page: this.optionsHistorial.page,
                    per_page: this.optionsHistorial.itemsPerPage
                }
            })
            .then((response) => {
                this.historialImportaciones = response.data.data;
                this.totalHistorial = response.data.total;
            })
            .catch((error) => {
                console.error("Error al cargar historial:", error);
                this.$toast.error("Error al cargar el historial de importaciones");
            })
            .finally(() => {
                this.cargandoHistorial = false;
            });
        },
        onHistorialOptionsUpdate(newOptions) {
            this.optionsHistorial = newOptions;
            this.cargarHistorial();
        },
        verDetalleImportacion(item) {
            this.detalleImportacion = null;
            axios.get(`api/detalle-importacion-ingresos/${item.id}`)
            .then((response) => {
                this.detalleImportacion = response.data;
                this.dialogDetalleImportacion = true;
            })
            .catch((error) => {
                console.error("Error al cargar detalle:", error);
                this.$toast.error("Error al cargar el detalle de la importación");
            });
        },
        cerrarDialogDetalle() {
            this.dialogDetalleImportacion = false;
            this.detalleImportacion = null;
        },
        getColorResultado(resultado) {
            switch(resultado) {
                case 'CREADO':
                    return 'success';
                case 'DUPLICADO':
                    return 'warning';
                case 'ERROR':
                    return 'error';
                default:
                    return 'grey';
            }
        },
        getTipoPago(item) {
            // Si hay ingreso_factura con múltiples facturas, mostrar todos los tipos de pago
            if (item.ingreso_factura && item.ingreso_factura.length > 0) {
                const tipos = item.ingreso_factura
                    .map(ingresoFactura => ingresoFactura.tipo_pago)
                    .filter(tipo => tipo != null && tipo !== '');
                
                if (tipos.length > 0) {
                    // Si todos son iguales, mostrar solo uno
                    const tiposUnicos = [...new Set(tipos)];
                    if (tiposUnicos.length === 1) {
                        return this.formatTipoPago(tiposUnicos[0]);
                    }
                    // Si hay diferentes, mostrar todos separados por comas
                    return tiposUnicos.map(t => this.formatTipoPago(t)).join(', ');
                }
            }
            
            // Si no hay ingreso_factura o no tiene tipo_pago, usar el del ingreso general
            if (item.tipo_pago) {
                return this.formatTipoPago(item.tipo_pago);
            }
            
            return null;
        },
        formatTipoPago(tipo) {
            const tipos = {
                'transferencia': 'Transferencia',
                'tarjeta': 'Tarjeta',
                'sepa': 'SEPA',
                'efectivo': 'Efectivo'
            };
            return tipos[tipo] || tipo;
        },

        // En desuso
        /*customSort(items, index, isDesc) {
            items.sort((a, b) => {
                if (index[0] == "nro_anio_factura") {
                    if (a.anio - b.anio == 0) {
                        if (!isDesc[0]) {
                            return a.nro_factura - b.nro_factura;
                        } else {
                            return b.nro_factura - a.nro_factura;
                        }
                    } else {
                        if (!isDesc[0]) {
                            return a.anio - b.anio;
                        } else {
                            return b.anio - a.anio;
                        }
                    }
                }
            });
            return items;
        },
        loadItems({ page, itemsPerPage, sortBy }) {
            this.page = page;
            this.itemsPerPage = itemsPerPage;
            this.getAllingresos();
        },*/
    },
    computed: {
        isloading: function () {
            return this.$store.getters.getloading;
        },
    },
};
</script>
